import { SectorStatItem } from './SectorStatItem';
import { InboxStats } from '../models';

interface StatsPanelGridProps {
  stats: InboxStats;
  sectors: string[];
}

export const StatsPanelGrid = ({ stats, sectors }: StatsPanelGridProps) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3 bg-white/95 backdrop-blur-md p-4 rounded-[2rem] shadow-xl border border-gray-100'>
      {sectors.map((sectorName) => (
        <div key={sectorName} className='min-w-0'>
          <SectorStatItem
            sectorName={sectorName}
            delivered={stats[sectorName].delivered}
            notDelivered={stats[sectorName].notDelivered}
            total={stats[sectorName].total}
            avg={stats[sectorName].avg}
          />
        </div>
      ))}
    </div>
  );
};
